
import { defineComponent, ref, Ref, onMounted, inject } from "vue";

import CloseSVG from "@/components/CloseSVG.vue";

export default defineComponent({
  name: "GuideLinesModal",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const title = ref("");

    onMounted(() => {
      title.value = "Guidelines";
    });

    return { closeModal, bounceTransition, fadeTransition, title };
  },
});
